import { render, staticRenderFns } from "./OCheckbox.vue?vue&type=template&id=3769d8a4&scoped=true&"
import script from "./OCheckbox.vue?vue&type=script&lang=js&"
export * from "./OCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3769d8a4",
  null
  
)

export default component.exports